// TO DO: Edit this to allow delete icon for multi-selects
import React from 'react';

const Tag = ({ label, colour }) => {
  const tagStyle = {
    display: 'inline-block',
    padding: '5px',
    backgroundColor: colour || '#F3F4F6',
    color: 'black',
    borderRadius: '5px',
    fontSize: '1rem',
    textAlign: 'center',
    margin: '4px'
  };

  return <span className="tag" style={tagStyle}>{label}</span>;
};

export default Tag;
